var moduleMap = {
	"./DogstarSlice": () => {
		return Promise.all([__webpack_require__.e(6616), __webpack_require__.e(3024), __webpack_require__.e(1695), __webpack_require__.e(780)]).then(() => (() => ((__webpack_require__(10780)))));
	},
	"./AssetsSlice": () => {
		return Promise.all([__webpack_require__.e(6752), __webpack_require__.e(6616), __webpack_require__.e(3024), __webpack_require__.e(8145), __webpack_require__.e(4750), __webpack_require__.e(9805)]).then(() => (() => ((__webpack_require__(29805)))));
	},
	"./AccountsSlice": () => {
		return Promise.all([__webpack_require__.e(6616), __webpack_require__.e(3024), __webpack_require__.e(8946), __webpack_require__.e(7716)]).then(() => (() => ((__webpack_require__(67716)))));
	},
	"./NavigationSlice": () => {
		return Promise.all([__webpack_require__.e(3024), __webpack_require__.e(5338)]).then(() => (() => ((__webpack_require__(95338)))));
	},
	"./Assets": () => {
		return Promise.all([__webpack_require__.e(6752), __webpack_require__.e(6616), __webpack_require__.e(3024), __webpack_require__.e(8145), __webpack_require__.e(4750)]).then(() => (() => ((__webpack_require__(4750)))));
	},
	"./Helpers": () => {
		return Promise.all([__webpack_require__.e(6616), __webpack_require__.e(3024), __webpack_require__.e(3374)]).then(() => (() => ((__webpack_require__(3374)))));
	},
	"./Swap": () => {
		return Promise.all([__webpack_require__.e(504), __webpack_require__.e(7931), __webpack_require__.e(2995), __webpack_require__.e(6616), __webpack_require__.e(8145), __webpack_require__.e(1695), __webpack_require__.e(6774), __webpack_require__.e(7983), __webpack_require__.e(126)]).then(() => (() => ((__webpack_require__(32038)))));
	},
	"./Horizon": () => {
		return Promise.all([__webpack_require__.e(6616), __webpack_require__.e(6240)]).then(() => (() => ((__webpack_require__(86240)))));
	},
	"./TradingView": () => {
		return Promise.all([__webpack_require__.e(6616), __webpack_require__.e(5089)]).then(() => (() => ((__webpack_require__(25089)))));
	},
	"./Accounts": () => {
		return Promise.all([__webpack_require__.e(6616), __webpack_require__.e(8946), __webpack_require__.e(4853)]).then(() => (() => ((__webpack_require__(14853)))));
	},
	"./FlipCards": () => {
		return __webpack_require__.e(3871).then(() => (() => ((__webpack_require__(23871)))));
	},
	"./Offers": () => {
		return Promise.all([__webpack_require__.e(504), __webpack_require__.e(7931), __webpack_require__.e(2995), __webpack_require__.e(6616), __webpack_require__.e(8145), __webpack_require__.e(1695), __webpack_require__.e(6774), __webpack_require__.e(7983), __webpack_require__.e(1306)]).then(() => (() => ((__webpack_require__(66474)))));
	},
	"./Trustline": () => {
		return Promise.all([__webpack_require__.e(504), __webpack_require__.e(7931), __webpack_require__.e(2995), __webpack_require__.e(6616), __webpack_require__.e(8145), __webpack_require__.e(1695), __webpack_require__.e(6774), __webpack_require__.e(7983), __webpack_require__.e(8293)]).then(() => (() => ((__webpack_require__(7027)))));
	},
	"./Pairs": () => {
		return Promise.all([__webpack_require__.e(6752), __webpack_require__.e(6616), __webpack_require__.e(3024), __webpack_require__.e(8145), __webpack_require__.e(4750), __webpack_require__.e(5858)]).then(() => (() => ((__webpack_require__(75858)))));
	},
	"./PoolsStellar": () => {
		return Promise.all([__webpack_require__.e(504), __webpack_require__.e(6752), __webpack_require__.e(7931), __webpack_require__.e(2995), __webpack_require__.e(6616), __webpack_require__.e(3024), __webpack_require__.e(8145), __webpack_require__.e(1695), __webpack_require__.e(6774), __webpack_require__.e(7983), __webpack_require__.e(4750), __webpack_require__.e(2642)]).then(() => (() => ((__webpack_require__(68754)))));
	},
	"./Coingecko": () => {
		return Promise.all([__webpack_require__.e(6616), __webpack_require__.e(3024), __webpack_require__.e(5397)]).then(() => (() => ((__webpack_require__(35397)))));
	},
	"./ClaimBalance": () => {
		return Promise.all([__webpack_require__.e(504), __webpack_require__.e(7931), __webpack_require__.e(2995), __webpack_require__.e(6616), __webpack_require__.e(8145), __webpack_require__.e(1695), __webpack_require__.e(6774), __webpack_require__.e(7983), __webpack_require__.e(8080)]).then(() => (() => ((__webpack_require__(75576)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});